import {
  collection,
  deleteDoc,
  doc,
  getDocs,
  limit,
  orderBy,
  query,
  runTransaction,
  serverTimestamp,
  updateDoc,
  where,
} from 'firebase/firestore'
import { dbService } from './FBase'

export const getUser = async (userUID: any) => {
  const user_uid = userUID.queryKey[1]
  try {
    const q = await query(
      collection(dbService, 'User'),
      where('uid', '==', user_uid)
    )

    const querySnapshot = await getDocs(q)
    const memberDoc = querySnapshot.docs[0]
    if (memberDoc) {
      const memberData = memberDoc.data()
      return {
        ...memberData,
      }
    }
  } catch (error) {
    console.log('error:', error)
  }
}

// 🗺 컬렉션에 맞는 데이터 리스트 가져오기
export const getItemsList = async (collectionType: string) => {
  const q = query(
    collection(dbService, collectionType),
    orderBy('createdAt', 'desc')
  )
  const querySnapshot = await getDocs(q)
  const items = querySnapshot.docs.map((doc) => ({
    ...doc.data(),
  }))

  return items
}

export const getIndustryCode = async () => {
  const q = query(collection(dbService, 'Industry'))
  const querySnapshot = await getDocs(q)
  const industryCode = querySnapshot.docs.map((doc) => ({
    ...doc.data(),
  }))

  return industryCode
}
